module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('div', {
    staticClass: "address"
  }, [_c('div', {
    staticClass: "data"
  }, [_c('img', {
    attrs: {
      "src": _vm.src
    }
  }), _vm._v(" "), _c('p', [_vm._v("4001 507 507（周一至周日：7:00 - 24:00）")]), _vm._v(" "), _c('p', [_vm._v("北京市海淀区北四环西路58号理想国际大厦11层")])]), _vm._v(" "), _c('div', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "id": "github",
      "href": "https://github.com/rianran1993/ofo",
      "target": "_blank"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "wechat",
      "href": "javascript:;"
    },
    on: {
      "mouseover": _vm.show,
      "mouseleave": _vm.hide
    }
  })])]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "company"
  }, [_c('p', [_vm._v("Copyright © 2017 ofo Inc. 保留所有权利。京公网安备 11010802022978号   |   公共事务邮箱  gr@ofo.so    商务合作邮箱  bdinchina@ofo.so")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-5af74f54"}!./~/.11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/footer.vue
// module id = 21
// module chunks = 0